import React, { useState } from "react";
import { Check, ChevronsUpDown, Search } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

/**
 * Combobox de proveedor con búsqueda por escritura.
 * Filtra por razón social, RUC, email.
 */
export function ProveedorCombobox({ value, onChange, proveedores = [], placeholder = "Buscar proveedor…", testId = "prov-combo", className }) {
  const [open, setOpen] = useState(false);
  const selected = proveedores.find(p => p.id === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className={cn("h-9 justify-between font-normal text-left w-full", !selected && "text-[#8ba397]", className)}
          data-testid={`${testId}-trigger`}
        >
          <span className="truncate">
            {selected ? (selected.razon_social || selected.nombre_comercial) : placeholder}
          </span>
          <ChevronsUpDown size={14} className="ml-2 opacity-50 shrink-0" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[460px] p-0" align="start">
        <Command shouldFilter={true}>
          <div className="flex items-center border-b border-[#d1dbd6] px-3" cmdk-input-wrapper="">
            <Search size={14} className="mr-2 shrink-0 opacity-50" />
            <CommandInput
              placeholder="Razón social, RUC, email…"
              className="flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-[#8ba397]"
              data-testid={`${testId}-input`}
            />
          </div>
          <CommandList className="max-h-[340px] overflow-y-auto">
            <CommandEmpty className="py-4 text-center text-sm text-[#8ba397]">Sin resultados</CommandEmpty>
            <CommandGroup>
              {proveedores.map(p => {
                const searchable = [p.razon_social, p.nombre_comercial, p.numero_identificacion, p.email].filter(Boolean).join(" ");
                return (
                  <CommandItem
                    key={p.id}
                    value={searchable}
                    onSelect={() => { onChange(p.id); setOpen(false); }}
                    data-testid={`${testId}-item-${p.id}`}
                  >
                    <Check size={14} className={cn("mr-2", value === p.id ? "opacity-100 text-[#205c45]" : "opacity-0")} />
                    <div className="flex flex-col">
                      <span className="font-medium">{p.razon_social || p.nombre_comercial}</span>
                      <span className="text-[11px] text-[#5c7368]">
                        {[p.numero_identificacion, p.email].filter(Boolean).join(" · ")}
                      </span>
                    </div>
                  </CommandItem>
                );
              })}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
